import { render, staticRenderFns } from "./recent-studies.vue?vue&type=template&id=78fd6dd4&scoped=true&"
import script from "./recent-studies.vue?vue&type=script&lang=ts&"
export * from "./recent-studies.vue?vue&type=script&lang=ts&"
import style0 from "./recent-studies.vue?vue&type=style&index=0&id=78fd6dd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fd6dd4",
  null
  
)

export default component.exports